import React from "react";

const projects = [
  {
    title: "Leaf Disease Detection",
    image: process.env.PUBLIC_URL + "/media/images/leafscan.png",
    desc: "Leaf Scan is an AI-powered web application that detects plant leaf diseases from images using deep learning.",
    tech: ["Python","Machine Learning" ,"TensorFlow", "OpenCV"],
    source: "https://github.com/tanveer-deol/leaf_scan",
    demo: "",
  },
  {
    title: "WanderLust",
    image: process.env.PUBLIC_URL + "/media/images/wanderlust.png",
    desc: "WanderLust is a full stack web dev project which is a replica of Airbnb.",
    tech: ["Javascript","Node.js","Express.js", "MongoDB","EJS","HTML5", "CSS3"],
    source: "https://github.com/tanveer-deol/Wanderlust",
    demo: "",
  },
  {
    title: "Zerodha-clone",
    image: process.env.PUBLIC_URL + "/media/images/Zerodha.png",
    desc: "Zerodha clone using the MERN stack",
    tech: ["React.js","Node.js","Express.js", "MongoDB","REST API","JWT Authentication"],
    source: "https://github.com/tanveer-deol/Zerodha",
    demo: "",
  },
];

function Projects() {
  return (
    <section id="projects" className="container mt-5">
      <h2 className="section-title">Projects</h2>
      {projects.map((p, i) => (
        <div className="project-card" key={i}>
          <img className="project-image" src={p.image} alt={p.title} />
          <div className="project-body">
            <p className="project-title">{p.title}</p>
            <p className="project-desc">{p.desc}</p>
            <div className="tech-grid mb-3">
              {p.tech.map((t) => (
                <span
                  key={t}
                  className="tech-card"
                  style={{ padding: "6px 12px" }}
                >
                  <p>{t}</p>
                </span>
              ))}
            </div>
            <div className="project-links">
              <a href={p.source} target="_blank" rel="noreferrer">
                <i className="fa-brands fa-github"></i>Source code
              </a>
              <a href={p.demo} target="_blank" rel="noreferrer">
                <i className="fa-solid fa-arrow-up-right-from-square"></i>Live demo
              </a>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default Projects;